module.exports = __webpack_public_path__ + "img/02_full.3993fd0f.jpg";